import React from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import {
  Container,
  Grid,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Collapse,
  Select,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  RadioGroup,
  Radio,
  FormControlLabel,
  TablePagination,
  Stack,
  Checkbox,
  Box,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  Delete,
  DoDisturbAlt,
  ExitToApp,
  MoreVert,
  ShareOutlined,
  Storefront,
  Twitter,
  Upload,
  WarehouseOutlined,
} from "@mui/icons-material";
import {
  get_upload_file,
  add_product_slider,
  edit_product_slider,
  delete_product_slider,
  get_best_seller_detail,
} from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import toast from "react-simple-toasts";
import useUser from "../../hooks/useUser";

export default function SliderDetail() {
  const classes = useStyles();
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  const { set_user, get_user } = useUser();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");
  const handleSearch = (event) => {
    setSearchKey(event.target.value);
  };

  const [loading, setLoading] = React.useState(false);
  const [pageNum, setPageNum] = React.useState(0);

  const [listData, setlistData] = React.useState(null);

  const [openAdd, setOpenAdd] = React.useState(false);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [openDelete, setOpenDelete] = React.useState(false);
  const [selectedSlider, setSelectedSlider] = React.useState(null);
  const [addData, setAddData] = React.useState({
    item_name: "",
    code: "",
    brand: "",
    color: "",
    image: "",
  });
  const [openEditCountry, setOpenEditCountry] = React.useState(false);
  const [countryData, setCountryData] = React.useState({
    shipping_country_id: "",
    default_shipping: "",
  });

  const [prods, setProds] = React.useState([]);
  const getData = () => {
    setLoading(true);
    get_best_seller_detail({
      product_title_id: params.product_title_id,
    }).then((json) => {
      setLoading(false);
      setlistData(json.data);
      setProds(json.data.products);
      //   setTotalList(json.total)
    });
  };

  React.useEffect(() => {
    getData();
  }, [pageNum, sort]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    // getData();
  };

  const [disabled, setDisabled] = React.useState(false);

  const handleCaptureSingle = async (e, index) => {
    setDisabled(true);
    var formData = new FormData();

    formData.append("image", e.target.files[0]);

    var res = await get_upload_file(formData);

    // console.log(res);
    if (res.data.status) {
      setDisabled(false);
      setAddData({
        ...addData,
        image: res.data.data,
      });
    } else {
      setDisabled(false);
      toast(res.data.message);
    }
  };

  const handleOpenAdd = (e) => {
    setOpenAdd(true);
    setAddData({
      item_name: "",
      code: "",
      brand: "",
      color: "",
      image: "",
    });
  };
  const handleCloseAdd = (value) => {
    setOpenAdd(false);
  };

  const handleChangeAdd = (e) => {
    setAddData({
      ...addData,
      [e.target.name]: e.target.value,
    });
  };

  const handleAdd = () => {
    if (addData.image.length == 0) {
      toast("Please upload image");
      return;
    }

    if (addData.item_name.length == 0) {
      toast("Please enter item name");
      return;
    }

    if (addData.code.length == 0) {
      toast("Please enter code");
      return;
    }
    if (addData.brand.length == 0) {
      toast("Please enter brand");
      return;
    }

    if (addData.color.length == 0) {
      toast("Please enter color");
      return;
    }
    setDisabled(true);

    let postparam = {
      ...addData,
      product_title_id: params.product_title_id,
    };

    console.log(postparam);

    add_product_slider(postparam).then((json) => {
      if (json.status) {
        setDisabled(false);
        toast("Product Added");
        handleCloseAdd();
        getData();
        setAddData({
          item_name: "",
          code: "",
          image: "",
          brand: "",
          color: "",
        });
      } else {
        setDisabled(false);
        toast(json.message);
      }
    });
  };

  const handleOpenEdit = (e) => {
    setOpenEdit(true);
    setAddData({
      item_name: e.item_name,
      code: e.code,
      image: e.image,
      brand: e.brand,
      color: e.color,
      product_title_id: e.product_title_id,
      product_id: e.product_id,
    });
  };
  const handleCloseEdit = (value) => {
    setOpenEdit(false);
  };

  const handleEdit = () => {
    if (addData.item_name.length == 0) {
      toast("Please enter item name");
      return;
    }

    if (addData.code.length == 0) {
      toast("Please enter code");
      return;
    }
    if (addData.brand.length == 0) {
      toast("Please enter brand");
      return;
    }

    if (addData.color.length == 0) {
      toast("Please enter color");
      return;
    }
    setDisabled(true);
    edit_product_slider({
      ...addData,
    }).then((json) => {
      if (json.status) {
        setDisabled(false);
        toast("Product Edited");
        handleCloseEdit();
        getData();
        setAddData({
          item_name: "",
          color: "",
          brand: "",
          code: "",
        });
      } else {
        setDisabled(false);
        toast(json.message);
      }
    });
  };

  const handleOpenDelete = (e) => {
    setOpenDelete(true);
    setSelectedSlider(e);
  };
  const handleCloseDelete = (value) => {
    setOpenDelete(false);
  };
  const handleDeleteSlider = () => {
    setLoading(true);
    delete_product_slider({ product_id: selectedSlider }).then((json) => {
      if (json.status) {
        setLoading(false);
        toast("Product Deleted");
        handleCloseDelete();
        getData();
      } else {
        setLoading(false);
        toast(json.message);
      }
    });
  };

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <React.Fragment>
          {/* {inventoryDetail != null && (
           
          )} */}
        </React.Fragment>
      )}
      <Navbar2
        children={
          <Section pd="2rem">
            <div>
              <div
                onClick={() => navigate(-1)}
                style={{
                  cursor: "pointer",
                }}
              >
                <Paragraph
                  color="#1A5386"
                  bold="400"
                  size="12px"
                  margin="0 0 1rem"
                >
                  &lt; Back
                </Paragraph>
              </div>
              <div className={classes.theFlexHeader}>
                {listData && (
                  <Paragraph
                    color="#1A5386"
                    bold="600"
                    size="24px"
                    style={{ textTransform: "uppercase" }}
                  >
                    {listData.title}
                  </Paragraph>
                )}
                <div
                  className={classes.theFlexBtn}
                  style={{ marginBottom: "0" }}
                >
                  <a
                    className={classes.theCustomActionBtn_}
                    onClick={() => handleOpenAdd()}
                  >
                    <AddCircle sx={{ color: "#1A5386" }} />
                    <Paragraph color="#1A5386" margin="0 0 0 .4rem">
                      Add Product
                    </Paragraph>
                  </a>
                </div>
              </div>

              <div
                style={{
                  borderBottom: "2px solid #707070",
                  padding: ".2rem 0",
                }}
              />
              <br />
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12} md={12}>
                  <Card className={classes.theCard}>
                    <TableContainer>
                      <Table>
                        <TableHead style={{ backgroundColor: "#1A5386" }}>
                          <TableRow>
                            <TableCell
                              style={{ borderRadius: "10px 0 0 10px" }}
                              className={classes.theHeadTitle}
                            >
                              Item Name
                            </TableCell>

                            <TableCell className={classes.theHeadTitle}>
                              Code
                            </TableCell>
                            <TableCell className={classes.theHeadTitle}>
                              Brand
                            </TableCell>
                            <TableCell className={classes.theHeadTitle}>
                              Color
                            </TableCell>

                            <TableCell className={classes.theHeadTitle}>
                              Image
                            </TableCell>
                            <TableCell
                              align="center"
                              style={{ borderRadius: "0 10px 10px 0" }}
                              className={classes.theHeadTitle}
                            >
                              <MoreVert sx={{ color: "#fff" }} />
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {prods.map((item, index) => (
                            <TableRow>
                              <a style={{ display: "contents" }}>
                                <TableCell
                                  style={{
                                    background:
                                      index % 2 == 0 ? "#f2f2f2" : "#fff",
                                    // width: "10%",
                                    verticalAlign: "top",
                                  }}
                                >
                                  <div>
                                    {item.item_name != "" &&
                                    item.item_name != null
                                      ? item.item_name
                                      : "-"}
                                  </div>
                                </TableCell>
                                <TableCell
                                  style={{
                                    background:
                                      index % 2 == 0 ? "#f2f2f2" : "#fff",
                                    // width: "10%",
                                    verticalAlign: "top",
                                  }}
                                >
                                  {item.code != "" && item.code != null
                                    ? item.code
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    background:
                                      index % 2 == 0 ? "#f2f2f2" : "#fff",
                                    // width: "10%",
                                    verticalAlign: "top",
                                  }}
                                >
                                  {item.brand != "" && item.brand != null
                                    ? item.brand
                                    : "-"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    background:
                                      index % 2 == 0 ? "#f2f2f2" : "#fff",
                                    // width: "10%",
                                    verticalAlign: "top",
                                  }}
                                >
                                  {item.color != "" && item.color != null
                                    ? item.color
                                    : "-"}
                                </TableCell>

                                <TableCell
                                  style={{
                                    background:
                                      index % 2 == 0 ? "#f2f2f2" : "#fff",
                                    // width: "10%",
                                    verticalAlign: "top",
                                  }}
                                >
                                  <img
                                    style={{ width: "80px" }}
                                    src={item.image}
                                  />
                                </TableCell>
                                <TableCell
                                  align="center"
                                  style={{
                                    background:
                                      index % 2 == 0 ? "#f2f2f2" : "#fff",
                                    // width: "10%",
                                    verticalAlign: "top",
                                  }}
                                >
                                  <Button
                                    onClick={() => handleOpenEdit(item)}
                                    label="Edit"
                                    color="#fff"
                                    bg="#1A5386"
                                    size="12px"
                                    pd="10px"
                                    br="5px"
                                    style={{ marginBottom: "10px" }}
                                  />
                                  <Button
                                    onClick={() =>
                                      handleOpenDelete(item.product_id)
                                    }
                                    label="Delete"
                                    color="#1A5386"
                                    bg="#fff"
                                    box="1px solid #1A5386"
                                    size="12px"
                                    pd="10px"
                                    br="5px"
                                  />
                                </TableCell>
                              </a>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Card>
                  <br />
                  <br />
                </Grid>
              </Grid>
              <br />
              <br />
            </div>

            <Dialog
              onClose={handleCloseAdd}
              open={openAdd}
              fullWidth="true"
              maxWidth="sm"
            >
              <DialogTitle>
                <Paragraph color="#1A5386" bold="600" size="24px">
                  Add Product
                </Paragraph>
              </DialogTitle>
              <DialogContent>
                <input
                  className="ori-fileinput"
                  type="file"
                  name="file"
                  style={{
                    marginBottom: "1rem",
                  }}
                  onChange={handleCaptureSingle}
                />

                <FormInput
                  label="Item Name*"
                  value={addData.item_name}
                  textLabelColor="#000"
                  placeholder="Item Name"
                  name="item_name"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />
                <FormInput
                  label="Code*"
                  value={addData.code}
                  textLabelColor="#000"
                  placeholder="Code"
                  name="code"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />

                <FormInput
                  label="Brand*"
                  value={addData.brand}
                  textLabelColor="#000"
                  placeholder="Brand"
                  name="brand"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />

                <FormInput
                  label="Color*"
                  value={addData.color}
                  textLabelColor="#000"
                  placeholder="Color"
                  name="color"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />

                <br />
                <Box>
                  {!disabled ? (
                    <Button
                      onClick={() => handleAdd()}
                      label="Submit"
                      color="#fff"
                      bg="#1A5386"
                      size="18px"
                      pd="10px"
                      br="5px"
                      style={{ marginBottom: "10px" }}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "35px",
                      }}
                    >
                      <Loader
                        type="snipper-default"
                        bgColor={"#878787"}
                        size={30}
                      />
                    </div>
                  )}
                </Box>
              </DialogContent>
            </Dialog>

            <Dialog
              onClose={handleCloseEdit}
              open={openEdit}
              fullWidth="true"
              maxWidth="sm"
            >
              <DialogTitle>
                <Paragraph color="#1A5386" bold="600" size="24px">
                  Edit Slider
                </Paragraph>
              </DialogTitle>
              <DialogContent>
                <input
                  className="ori-fileinput"
                  type="file"
                  name="file"
                  style={{
                    marginBottom: "1rem",
                  }}
                  onChange={handleCaptureSingle}
                />

                <FormInput
                  label="Item Name*"
                  value={addData.item_name}
                  textLabelColor="#000"
                  placeholder="Item Name"
                  name="item_name"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />
                <FormInput
                  label="Code*"
                  value={addData.code}
                  textLabelColor="#000"
                  placeholder="Code"
                  name="code"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />

                <FormInput
                  label="Brand*"
                  value={addData.brand}
                  textLabelColor="#000"
                  placeholder="Brand"
                  name="brand"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />

                <FormInput
                  label="Color*"
                  value={addData.color}
                  textLabelColor="#000"
                  placeholder="Color"
                  name="color"
                  border="1px solid #c5c5c5"
                  onChange={handleChangeAdd}
                />
                <br />

                <Box>
                  {!disabled ? (
                    <Button
                      onClick={() => handleEdit()}
                      label="Save"
                      color="#fff"
                      bg="#1A5386"
                      size="18px"
                      pd="10px"
                      br="5px"
                      style={{ marginBottom: "10px" }}
                    />
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "35px",
                      }}
                    >
                      <Loader
                        type="snipper-default"
                        bgColor={"#878787"}
                        size={30}
                      />
                    </div>
                  )}
                </Box>
              </DialogContent>
            </Dialog>

            <Dialog
              onClose={handleCloseDelete}
              open={openDelete}
              fullWidth="true"
              maxWidth="sm"
            >
              <DialogTitle>
                <Paragraph color="#1A5386" bold="600" size="24px">
                  Delete Slider
                </Paragraph>
              </DialogTitle>
              <DialogContent>
                <Paragraph
                  color="#000"
                  bold="600"
                  size="16px"
                  margin="0 0 1rem"
                >
                  Are you sure to delete this Slider?
                </Paragraph>
                <Button
                  onClick={() => handleDeleteSlider()}
                  label="Delete"
                  color="#fff"
                  bg="#1A5386"
                  size="18px"
                  pd="10px"
                  br="5px"
                  style={{ marginBottom: "10px" }}
                />
              </DialogContent>
            </Dialog>
          </Section>
        }
      />
    </React.Fragment>
  );
}
